import classNames from 'classnames';
import * as React from 'react';
import styles from './Tooltip.module.scss.js';

var TooltipHeader = function (props) {
    var _a;
    var classNameHeader = classNames(styles.header, (_a = {},
        _a[styles.isHelpIcon] = props.isHelpIcon,
        _a[styles.isBold] = props.isBold,
        _a), props.className);
    return React.createElement("div", { className: classNameHeader }, props.children);
};

export { TooltipHeader as default };
//# sourceMappingURL=TooltipHeader.js.map
